import FeatureTogglingRender from "../../../conditionalRender/featureTogglingRender";

require('./brokerMyInvestmentsProductsRow.scss');

const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const moment = require('moment');
const classnames = require('classnames');

// @commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @components
const { BrokerPlanContributionButton } = require('components/broker/brokerPlanContributionButton/brokerPlanContributionButton');
const { BrokerFundContributionButton } = require('components/broker/brokerFundContributionButton/brokerFundContributionButton');
const Flag = require('components/broker/commons/flag/flag');
const BrokerMiFIDUSPersonButton = require('mifid/components/brokerMiFIDUSPersonButton/brokerMiFIDUSPersonButton');
const BrokerMyInvestmentsFundSellButton = require('components/broker/myInvestments/brokerMyInvestmentsFundSellButton/brokerMyInvestmentsFundSellButton');

// @helpers
const { buildLinks } = require('utilities/fundsHelper');
const { formatAmount, formatWithoutRound } = require('utilities/currencyHelper');
const { formatSymbol } = require("utilities/cryptoUtils");
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { getPublicSitePathByLanguaje } = require('core/apiURLBuilder');
const { sendTextToClipBoard } = require('commonsUtilities/clipBoardHelper');
const { taggingEventHandled } = require("utilities/taggingEventHandled");
const { valueOrHyphen, conditionalValueOrHyphen } = require('utilities/valueHelper');
const DateHelper = require('utilities/dateHelper');
const SanitizeHelper = require('utilities/sanitizeHelper');

// @constants
const {
    BROKER_NON_NATIONAL_IDS_VALIDATION_TYPES,
    BROKER_SMALL_FLAG_SIZE,
    BROKER_TYPE_STOCKS_NEW_DECIMALS,
    BROKER_TYPE_STOCKS_OLD_DECIMALS_A,
    DATE_FORMAT_API,
    DATE_FORMAT_DAY_MONTH_SHORT,
    DATE_FORMAT_SHORT_TIME_24,
    EURO_TEXT,
    HYPHEN,
    MYPROFILE_BROKER_CRYPTO_URL,
    MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND,
    TYPE_ACTIVOS_DIGITALES,
    TYPE_ACTIVOS_REALES,
    TYPE_ALTERNATIVE_FUNDS_PG,
    TYPE_CRYPTO_PG,
    TYPE_DERECHOS,
    TYPE_ETFS,
    TYPE_FUNDS,
    TYPE_FUTURES,
    TYPE_GESTION_ALTERNATIVA,
    TYPE_MERCADO_MONETARIO,
    TYPE_MIXTOS,
    TYPE_OTHERS,
    TYPE_PLANS,
    TYPE_RENTA_FIJA,
    TYPE_RENTA_VARIABLE,
    TYPE_STOCKS,
    TYPE_WARRANTS,
    BROKER_MYPROFILE_CRYPTO_BUY_URL,
    BROKER_MYPROFILE_CRYPTO_SELL_URL,
} = require('constants/index');
const { ESG_PRODUCT, TYPE_ALTERNATIVE_FUNDS, FUNDS_PERIODIC_CONTRIBUTION, SHOW_GLOBAL_POSITION_CRYPTO} = require('constants/flagBasedFeatures');
const typeMatches = {
    ACCIONES: 'stocks',
    ETF: 'etfs',
    WARRANTS: 'warrants',
    OTROS: 'others',
    DERECHOS: 'derechos',
    CRYPTO: 'CRYPTO',
};

class BrokerMyInvestmentsProductsRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nextLocation: null
        };
        this.buildRow = this.buildRow.bind(this);
        this.buildBuyButton = this.buildBuyButton.bind(this);
        this.buildSellButton = this.buildSellButton.bind(this);
        this.buildContractNumber = this.buildContractNumber.bind(this);
    }

    getBuyButtonText(type) {
        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
            case TYPE_CRYPTO_PG:
                return formatText('broker-myInvestmentsBuyLink');
            case TYPE_FUNDS:
            case TYPE_ALTERNATIVE_FUNDS_PG:
                return formatText('broker-myInvestmentsSuscribeLink');
            case TYPE_PLANS:
                return formatText('broker-myInvestmentsContributeLink');
            default:
        }
    }

    getBuyLink(type, value) {
        const isin = value.get('isin');
        const iso = value.get('iso');
        const customInstitutionSecurityId = value.get('customInstitutionSecurityId');
        const fundId = value.get('id')
        switch (type) {
            case TYPE_ALTERNATIVE_FUNDS_PG:
                return `/myprofile/broker/buyAlternativeInvestmentFunds/${isin}/${fundId}`;
            case TYPE_FUNDS:
                return `/myprofile/broker/buyInvestmentFunds/${customInstitutionSecurityId}/${fundId}`;
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
            case TYPE_PLANS:
                return `/myprofile/broker/${type}Buy/${isin}/${iso}`;
            case TYPE_CRYPTO_PG:
                return `${BROKER_MYPROFILE_CRYPTO_BUY_URL}${value.get('shortSymbol')?.toLowerCase()}`;
        }
    }

    getCode(finalType, immStock) {
        switch (finalType) {
            case TYPE_ALTERNATIVE_FUNDS_PG:
            case TYPE_FUNDS:
            case TYPE_ETFS:
            case TYPE_WARRANTS:
            case TYPE_CRYPTO_PG:
                const isin = immStock.get('isin') ? immStock.get('isin') : HYPHEN;
                return <FormattedText value="broker-isinLabel" injectedStrings={[isin]} />;
            case TYPE_STOCKS:
                return immStock.get('tickerCode') ? immStock.get('tickerCode') : HYPHEN;
            case TYPE_PLANS:
                const dgsCode = immStock.get('isin') ? immStock.get('isin') : HYPHEN;
                return <FormattedText value="broker-dgsLabel" injectedStrings={[dgsCode]} />;
        }
    }

    getContract(contractType, compareIsin, contractNumber) {
        const { immMyInvestments } = this.props;
        const products = immMyInvestments.get('products');
        let contract = null;

        if (products.get(contractType) && products.get(contractType).get('stocks')) {
            const stocks = products.get(contractType).get('stocks');
            const stock = stocks.find(stock => stock.get('contract') === contractNumber);
            if (stock) {
                contract = stock.get('contract');
            }
        }

        return contract;
    }

    getFlag(finalType, immStock){
        switch (finalType) {
            case TYPE_STOCKS:
            case TYPE_ETFS:
            case TYPE_WARRANTS:
                return (
                    <div className="broker-products-table-row__flag">
                        <Flag countryCode={immStock.get('countryCode')} pixelsSize={BROKER_SMALL_FLAG_SIZE}/>
                    </div>
                );
        }
    }

    getMarketName(finalType, immStock){
        const marketName = immStock.get('shortMarketName') ? immStock.get('shortMarketName') : null ;
        switch (finalType) {
            case TYPE_CRYPTO_PG:
            case TYPE_STOCKS:
            case TYPE_ETFS:
                return marketName;
        }
        return null;
    }

    getSellButtonText(type) {
        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
            case TYPE_CRYPTO_PG:
                return formatText('broker-myInvestmentsSellLink');
            case TYPE_FUNDS:
                return formatText('broker-myInvestmentsReimburseLink');
            case TYPE_ALTERNATIVE_FUNDS_PG:
                    return formatText('broker-myInvestmentsReimburseLink');
            case TYPE_PLANS:
                return formatText('broker-myInvestmentsTraspassLink');
        }
    }

    getSellLink(type, value) {
        const isin = value.get('isin');
        const iso = value.get('iso');
        const emisionCode = value.get('emisionCode');
        const valueCode = value.get('valueCode');
        const customInstitutionSecurityId = value.get('customInstitutionSecurityId');
        const contractNumber = value.get('contractNumber') || value.get('numerodecontrato');

        switch (type) {
            case TYPE_FUNDS:
                return `/myprofile/broker/reimburseInvestment/${customInstitutionSecurityId}/${contractNumber}`;
            case TYPE_STOCKS:
                let stocksPath = `/myprofile/broker/${type}Sell/${isin}/${iso}/${emisionCode}/${valueCode}`;
                if (this.props.isContractSection) {
                    return stocksPath + `/${contractNumber}`;
                }
                return stocksPath;
            case TYPE_WARRANTS:
            case TYPE_ETFS:
            case TYPE_PLANS:
                return `/myprofile/broker/${type}Sell/${isin}/${iso}/${emisionCode}/${valueCode}`;
            case TYPE_CRYPTO_PG:
                return `${BROKER_MYPROFILE_CRYPTO_SELL_URL}${value.get('shortSymbol')?.toLowerCase()}`;
        }
    }

    buildAmountCurrency(amount, currency) {
        return (
            <span className="broker-products-table-row__span-earnings">
                <span className="broker-products-table-row__amount">{amount}</span>
                <span className="broker-products-table-row__currency">{currency}</span>
            </span>
        );
    }

    buildAmountCurrencyEur(amount, currency) {
        return (
            <span className="broker-products-table-row__second-row-eur">
                <span className="broker-products-table-row__amount-eur">{amount}</span>
                <span className="broker-products-table-row__currency-eur">{currency}</span>
            </span>
        );
    }

    buildAveragePriceEurLabelFor(immStock) {
        const averagePrice = immStock.getIn(['averagePriceEur','amount']);
        const averagePriceCurrency = immStock.getIn(['averagePriceEur','currency']);
        const averagePriceFormatted = formatWithoutRound(averagePrice, 3);
        return (this.buildAmountCurrencyEur(averagePriceFormatted, averagePriceCurrency));
    }

    buildAveragePriceLabelFor(immStock) {
        const averagePrice = immStock.get('averagePrice');
        const averagePriceCurrency = immStock.get('averagePriceCurrency');
        if (!averagePriceCurrency) {
            return <span>{HYPHEN}</span>;
        }
        const averagePriceFormatted = formatWithoutRound(averagePrice, 3);
        return (this.buildAmountCurrency(averagePriceFormatted, averagePriceCurrency));
    }

    buildBuyButton(immStock, handleBuy, finalType, productName, immFlagBasedFeatures) {
        const marketable = immStock.get('marketable');
        const buyButtonLabel = this.getBuyButtonText(finalType);
        const disabledTooltipText = immStock.get('marketableTooltipText');
        const fundId = immStock.get('id');
        const isin = immStock.get('isin');
        const secId = immStock.get('customInstitutionSecurityId');
        const contractNumber = immStock.get('contractNumber');
        const ffContributions = immFlagBasedFeatures.get(FUNDS_PERIODIC_CONTRIBUTION)
        const contributionList = this.props.immFundsContributionsList?.getIn(['list', 'recurringTransfers'])
        const contributionListError = this.props.immFundsContributionsList?.get('error')
        const hasContribution = contributionList ? contributionList.find(contribution => contribution.get('contractCode') === contractNumber) : false;
        return (
            finalType === TYPE_FUNDS && (!hasContribution && !contributionListError && ffContributions) ?
            <BrokerFundContributionButton
                fundId={fundId}
                secId={secId}
                contractNumber={isin}
                disabled={!marketable}
                productName={productName}
                finalType={finalType}
                pageName={this.props.pageName}
            />
            :
            <BrokerMiFIDUSPersonButton
                modifier="secondary"
                size="compact"
                onClick={() => handleBuy(productName)}
                isinId={immStock.get('isin')}
                marketId={immStock.get('iso')}
                disabled={!marketable}
                disabledTooltipText={disabledTooltipText}
            >
                <div className="broker-products-table-row__buy-button">
                    {buyButtonLabel}
                </div>
            </BrokerMiFIDUSPersonButton>
        );
    }

    buildContractNumber(immStock, type) {
        if (type == TYPE_DERECHOS) {
            return (
                <FormattedText
                    className="broker-products-table-row__contract-number-label"
                    value="broker-derechosCorrespondidos"
                />
            );
        }

        if (this.props.isContractSection || !immStock) {
            return null;
        }

        const contractForTooltip = immStock.get('contractForTooltip');
        const tooltipContent = this.buildTooltipContent(contractForTooltip);
        const textAndCroppedContractNumber = (
            <span>
                <FormattedText
                    className="broker-products-table-row__contract-number-label"
                    value="broker-myInvestmentsWrappedProductsTableContractLabel"
                />
                <span className="broker-products-table-row__contract-number-value">
                    {getLastNChars(contractForTooltip)}
                </span>
            </span>
        );

        return (
            <div className="broker-products-table-row__contract-number">
                <OKTooltip
                    target={textAndCroppedContractNumber}
                    content={tooltipContent}
                    offset={[34, -10]}
                    type="descriptive"
                />
            </div>
        );
    }

    buildFormattedQuoteDate(immStock) {
        const quoteDate = immStock.get('quoteDate');
        const quoteTime = immStock.get('quoteTime');

        const parsedQuoteDate = moment(quoteDate, DATE_FORMAT_API);
        const parsedQuoteTime = moment(quoteTime, 'HH:mm:ss');

        const formattedQuoteDate =
            parsedQuoteDate.isValid() ?
            DateHelper.buildFormattedDate(parsedQuoteDate, DATE_FORMAT_DAY_MONTH_SHORT) :
            HYPHEN;

        const formattedQuoteTime =
            parsedQuoteTime.isValid() ?
            DateHelper.buildFormattedDate(parsedQuoteTime, DATE_FORMAT_SHORT_TIME_24) :
            HYPHEN;

        const quoteDateIsToday = moment().isSame(parsedQuoteDate, 'day');

        if (quoteDateIsToday) {
            const todayLabel = formatText('broker-todayMyInvestmentsProductsTable');
            return `${todayLabel}, ${formattedQuoteTime}`;
        } else {
            return `${formattedQuoteDate}, ${formattedQuoteTime}`;
        }
    }

    buildInvestmentEurLabelFor(immStock) {
        const investmentEur = immStock.getIn(['investmentEur','amount']);
        const profitabilityEur = immStock.getIn(['earningsEur','amount']);
        if (investmentEur == null || profitabilityEur == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const investmentFormatted = formatWithoutRound(investmentEur, 2);
        const investmentFormattedCurrency = immStock.getIn(['investmentEur','currency']);

        return (this.buildAmountCurrencyEur(investmentFormatted, investmentFormattedCurrency));
    }

    buildInvestmentLabelFor(immStock) {
        const investment = immStock.get('investment');
        const profitability = immStock.get('earnings');

        if (investment == null || profitability == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const investmentFormatted = formatWithoutRound(investment, 2);
        const investmentFormattedCurrency = immStock.get('investmentCurrency');

        return this.buildAmountCurrency(investmentFormatted, investmentFormattedCurrency);
    }

    buildMarketName(immStock, type) {
        if (type === TYPE_OTHERS) {
            const marketName = valueOrHyphen(immStock.get('shortMarketName'));
            const isin = valueOrHyphen(immStock.get('isin'));

            return (
                <div className="broker-products-table-row__market-isin">
                    {marketName} | <FormattedText value="broker-isinLabel" injectedStrings={[isin]}/>
                </div>
            );
        }
    }

    buildProfitability(amountCurrency, percentage) {
        return (
            <div className="broker-products-table-row__earnings-row">
                {amountCurrency}
                <span className="broker-products-table-row__earnings-separator">|</span>
                <span className="broker-products-table-row__earnings-percentage">
                    {percentage}%
                </span>
            </div>
        );
    }

    buildProfitabilityEurLabelFor(immStock) {
        const profitabilityEur = immStock.getIn(['earningsEur', 'amount']);
        const investmentEur = immStock.getIn(['investmentEur', 'amount']);

        if (profitabilityEur == null || investmentEur == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const percentageEur = immStock.get('profitablePercentageEuros');
        const currencyEur = immStock.getIn(['earningsEur','currency']);

        const profitabilityPercentage = formatWithoutRound(percentageEur, 2);
        const profitabilityFormatted = formatWithoutRound(profitabilityEur, 2);
        const amountCurrencyEur = this.buildAmountCurrencyEur(profitabilityFormatted, currencyEur);
        return this.buildProfitability(amountCurrencyEur, profitabilityPercentage);
    }

    buildProfitabilityLabelFor(immStock) {
        const profitability = immStock.get('earnings');
        const investment = immStock.get('investment');

        if (profitability == null || investment == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const percentage = immStock.get('profitablePercentage');
        const currency = immStock.get('earningsCurrency');

        const profitabilityPercentage = formatWithoutRound(percentage, 2);
        const profitabilityFormatted = formatWithoutRound(profitability, 2);
        const amountCurrency = this.buildAmountCurrency(profitabilityFormatted, currency);
        return this.buildProfitability(amountCurrency, profitabilityPercentage);
    }

    buildQuoteAmount(quoteObject, finalType) {
        if(finalType === TYPE_DERECHOS) {
            return null;
        }

        if (finalType === TYPE_OTHERS || quoteObject.amount===null) {
            return <span>{HYPHEN}</span>;
        }
        const decimals = finalType === TYPE_STOCKS ? BROKER_TYPE_STOCKS_NEW_DECIMALS : BROKER_TYPE_STOCKS_OLD_DECIMALS_A;
        const quoteAmountFormatted = formatWithoutRound(quoteObject.amount, decimals);
        return (this.buildAmountCurrency(quoteAmountFormatted, quoteObject.currency));
    }

    buildQuoteAmountEur(quoteObjectEur, finalType) {
        if (finalType === TYPE_OTHERS || quoteObjectEur.amount===null) {
            return <span>{HYPHEN}</span>;
        }
        const decimals = finalType === TYPE_STOCKS ? BROKER_TYPE_STOCKS_NEW_DECIMALS : BROKER_TYPE_STOCKS_OLD_DECIMALS_A;
        const quoteAmountFormatted = formatWithoutRound(quoteObjectEur.amount, decimals);
        return this.buildAmountCurrencyEur(quoteAmountFormatted, quoteObjectEur.currency);
    }

    buildSellButton(immStock, sellButtonLabel, handleSell, finalType, productName) {
        const contractNumber = immStock.get('contractNumber');
        const ffContributions = this.props.immFlagBasedFeatures.get(FUNDS_PERIODIC_CONTRIBUTION)
        const contributionList = this.props.immFundsContributionsList?.getIn(['list', 'recurringTransfers'])
        const contributionListError = this.props.immFundsContributionsList?.get('error')
        const contributionDetails = contributionList?.find(contribution => contribution.get('contractCode') === contractNumber);
        const hasContribution = contributionDetails ? true : false
        switch (finalType) {
            case TYPE_PLANS:
                return (
                    <OKButton modifier="ghost" size="compact" onClick={() => handleSell(productName)}>
                        <div>
                            {sellButtonLabel}
                        </div>
                    </OKButton>
                );
            case TYPE_FUNDS:
                const handleInternalTransferFundClick = () => {
                    if (immStock.get('totalValue') > 0) {
                        const fundId = immStock.get('id');
                        if (hasContribution && !contributionListError && ffContributions) {
                            this.props.onPreSelectOriginInternalTransferFund(fundId, hasContribution, contributionDetails);
                        }
                        else this.props.onPreSelectOriginInternalTransferFund(fundId);

                    }
                    taggingEventHandled(this.props.pageName, 'actionButtonSell', productName, {finalType, extraTag:' - Transfer'});
                    this.props.history.push(MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND);
                }

                const investment = immStock.get('investment');
                return (!!investment && investment !== 0) ? (
                    <BrokerMyInvestmentsFundSellButton
                        buttonLabel={sellButtonLabel}
                        onClickSell={() => handleSell(productName)}
                        onInternalTransferFundClick={handleInternalTransferFundClick}
                    />
                ) : null;
            default:
                return (
                    <OKButton modifier="ghost" size="compact" onClick={() => handleSell(productName)}>
                        <div className="broker-products-table-row__sell-button">
                            {sellButtonLabel}
                        </div>
                    </OKButton>
                );
        }
    }

    buildRow(immStock, type) {
        //if type is not specified in a table level, then we need to obtain it from
        //the product itself
        const { immFlagBasedFeatures } = this.props;
        const ffAlternativeFunds = immFlagBasedFeatures.get(TYPE_ALTERNATIVE_FUNDS);
        const ffCrypto = immFlagBasedFeatures.get(SHOW_GLOBAL_POSITION_CRYPTO);
        const productType = immStock.get('productType');
        const productCategory = immStock.get('productCategory');
        let finalType;
        if(type == TYPE_RENTA_FIJA || type == TYPE_RENTA_FIJA || type == TYPE_MERCADO_MONETARIO || type == TYPE_RENTA_VARIABLE || type == TYPE_GESTION_ALTERNATIVA || type == TYPE_ACTIVOS_REALES || type == TYPE_MIXTOS || type == TYPE_ACTIVOS_DIGITALES){
            finalType = typeMatches[productType] ? typeMatches[productType] : TYPE_FUNDS;
        } else {
            finalType = typeMatches[productType] ? typeMatches[productType] : type;
        }
        const sellButtonLabel = this.getSellButtonText(finalType);
        const value = formatWithoutRound(immStock.get('totalValue'), 2);
        const valueCurrency = immStock.get('totalValueCurrency');
        const valueEur = formatWithoutRound(immStock.getIn(['totalValueEur','amount']), 2);
        const valueCurrencyEur = immStock.getIn(['totalValueEur','currency']);
        const quote = immStock.get('quote');
        const quoteCurrency = immStock.get('quoteCurrency');
        const quoteEur = immStock.getIn(['quoteEur','amount']);
        const quoteCurrencyEur = immStock.getIn(['quoteEur','currency']);
        const contractNumber = immStock.get('numerodecontrato');
        const shares = immStock.get('shares');
        const percentageInWallet = immStock.get('percentageInWallet');
        const proportionRightsRatio = immStock.get('proportionRightsRatio');
        const proportionSharesRatio = immStock.get('proportionSharesRatio');
        const isEsg = immStock.get('esg', false);
        const sellLink = this.getSellLink(finalType, immStock);
        const buyLink = this.getBuyLink(finalType, immStock);
        const productFileLink = this.productFileLink(finalType, immStock);

        const quoteObject = {
            amount: quote,
            currency: quoteCurrency
        };

        const quoteObjectEur = {
            amount: quoteEur,
            currency: quoteCurrencyEur
        };

        let formattedValue = HYPHEN;
        if (value && valueCurrency) {
            formattedValue = this.buildAmountCurrency(value, valueCurrency);
        }
        const formattedPercentageInWallet = percentageInWallet < 1 ? '< 1' : Math.round(percentageInWallet);

        let formattedShares =
            finalType === TYPE_PLANS || finalType === TYPE_FUNDS ?
            formatWithoutRound(shares, 3) :
            formatWithoutRound(shares);

        if (finalType === TYPE_DERECHOS) {
            const derechosProportion = `(${proportionRightsRatio} x ${proportionSharesRatio})`
            formattedShares = `${formattedShares} ${derechosProportion}`;
        }

        const quoteAmountBlock = this.buildQuoteAmount(quoteObject, finalType);
        const handleSell = this.handleSell.bind(this, immStock, sellLink, contractNumber, finalType);
        const handleBuy =  type === TYPE_CRYPTO_PG
            ? () => this.props.history.push(buyLink)
            : this.handleBuy.bind(this, buyLink, finalType);

        let formattedInvestment;
        let formattedEarnings;
        let averagePriceBlock;

        if(finalType !== TYPE_DERECHOS) {
            formattedInvestment = this.buildInvestmentLabelFor(immStock);
            formattedEarnings = this.buildProfitabilityLabelFor(immStock);
            averagePriceBlock = this.buildAveragePriceLabelFor(immStock);
        }

        let parsedDate = this.buildFormattedQuoteDate(immStock);

        if (finalType === TYPE_OTHERS && !quoteObject.amount) {
            parsedDate = undefined;
        }
        let operateButtons;
        let productName = SanitizeHelper.sanitizeData(immStock.get('name'));
        if (finalType === TYPE_PLANS) {
            const planId = immStock.get('customInstitutionSecurityId');
            const contractNumber = immStock.get('numerodecontrato');
            const marketable = immStock.get('marketable');
            operateButtons = (
                <div onClick={() =>
                    taggingEventHandled(this.props.pageName, 'contributeButton', getShortProductName(), finalType)
                }>
                    <BrokerPlanContributionButton
                        planId={planId}
                        contractNumber={contractNumber}
                        disabled={!marketable}
                        productName={productName}
                        finalType={finalType}
                        pageName={this.props.pageName}

                    />
                </div>

            );
        } else if ((finalType !== TYPE_OTHERS && finalType !== TYPE_DERECHOS && immStock.get('isin') && immStock.get('iso')) || finalType === TYPE_FUNDS) {
            operateButtons = (
                <div>
                    {this.buildSellButton(immStock, sellButtonLabel, handleSell, finalType, productName)}
                    {this.buildBuyButton(immStock, handleBuy, finalType, productName, immFlagBasedFeatures)}
                </div>
            );
        } else if (finalType === TYPE_ALTERNATIVE_FUNDS_PG && ffAlternativeFunds) {
            operateButtons = (
                <div>
                    {this.buildBuyButton(immStock, handleBuy, finalType, productName, immFlagBasedFeatures)}
                </div>
            );
        } else if(finalType === TYPE_CRYPTO_PG && ffCrypto) {
            operateButtons = (
                <div>
                    {this.buildBuyButton(immStock, handleBuy, finalType, productName, immFlagBasedFeatures)}
                </div>
            );
        }

        if (finalType !== TYPE_OTHERS && finalType !== TYPE_DERECHOS) {
            productName = (
                <OKLink to={productFileLink}>{productName}</OKLink>
            );
        }

        let averagePriceEurBlock;
        let formattedInvestmentEur;
        let quoteAmountEurBlock;
        let formattedValueEur;
        let formattedEarningsEur;
        let doubleRow = false;

        if (quoteCurrency !== EURO_TEXT && quoteCurrency && finalType !== TYPE_OTHERS &&
            finalType !== TYPE_PLANS && finalType !== TYPE_FUTURES && finalType !== TYPE_DERECHOS) {
            formattedValueEur = HYPHEN;
            averagePriceEurBlock = this.buildAveragePriceEurLabelFor(immStock);
            formattedInvestmentEur = this.buildInvestmentEurLabelFor(immStock);
            quoteAmountEurBlock = this.buildQuoteAmountEur(quoteObjectEur, finalType);
            if (valueEur && valueCurrencyEur) {
                formattedValueEur = this.buildAmountCurrencyEur(valueEur, valueCurrencyEur);
            }
            formattedEarningsEur = this.buildProfitabilityEurLabelFor(immStock);
            doubleRow = true;
        }

        const quoteValue = (
            <span className="broker-products-table-row__quote">
                {quoteAmountBlock}
            </span>
        );

        const quoteFullDate = (
            <span className="broker-products-table-row__quote-full-date">
                {parsedDate}
            </span>
        )

        let quoteTooltip;
        if (quote !== null) {
            quoteTooltip = (
                <OKTooltip
                    target={quoteValue}
                    content={quoteFullDate}
                    placement="top"
                    offset={[20, -6]}
                />);
        } else {
            quoteTooltip = quoteValue;
        }

        const divider =
            this.hasUnconsolidatedOperations(immStock) ?
            this.buildUnconsolidatedOperationsDivider(finalType) :
            null;

        const rowClassName = classnames('broker-products-table-row', {
            'broker-products-table-row__double': doubleRow,
            [`broker-products-table-row__${productCategory}`]: !!productCategory
        });

        const borderClassName = classnames('broker-products-table-row__color-code', {
            [`broker-products-table-row__color-code-${finalType}`]: !!productCategory
        });

        const getShortProductName = () => SanitizeHelper.sanitizeData(immStock.get('name'));

        return (
            <OKTableRow className={rowClassName}>
                <OKTableCell className="broker-products-table-row__name">
                    <div>
                        <div className={borderClassName}></div>
                        <div onClick={() =>
                            taggingEventHandled(this.props.pageName, 'productLink', getShortProductName(), finalType)
                        }
                            className="broker-products-table-row__product-name">
                            {productName}
                        </div>
                        <div className="broker-products-table-row__product-code">
                            {this.showFlagMarketAndCode(finalType, immStock)}
                        </div>
                        {this.buildMarketName(immStock, finalType)}
                        {this.buildContractNumber(immStock, finalType)}
                    </div>
                    {this.buildUnconsolidatedOperations(immStock, finalType)}
                </OKTableCell>
                {
                    type === TYPE_FUNDS ?
                        <FeatureTogglingRender notAllowedProductKey={ESG_PRODUCT}>
                            <OKTableCell className="broker-products-table-row__esg broker-products-table-row__cell-vertical-align--center">
                                {isEsg ? <i className="broker-products-table-row__icon-esg" /> : null}
                            </OKTableCell>
                        </FeatureTogglingRender> :
                        null
                }
                <OKTableCell
                    alignment="right"
                    className="broker-products-table-row__shares broker-products-table-row__cell-vertical-align--center"
                >
                    <div>
                        {formattedShares}
                    </div>
                    <div className="broker-products-table-row__second-row">
                        {this.buildUnconsolidatedOperationsValues(immStock, finalType, true)}
                    </div>
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-products-table-row__average-price-row broker-products-table-row__cell-vertical-align--center"
                >
                    <span>
                        <span className="broker-products-table-row__average-price">
                            {averagePriceBlock}
                        </span>
                        <span className="broker-products-table-row__average-price-eur">
                            {averagePriceEurBlock}
                        </span>
                    </span>
                    <div className="broker-products-table-row__second-row">
                        {divider}
                    </div>
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-products-table-row__investment-row broker-products-table-row__cell-vertical-align--center"
                >
                    <span>
                        <span className="broker-products-table-row__investment">
                            {formattedInvestment}
                        </span>
                        <span className="broker-products-table-row__investment-eur">
                            {formattedInvestmentEur}
                        </span>
                    </span>
                    <div className="broker-products-table-row__second-row">
                        {divider}
                    </div>
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-products-table-row__quote-row broker-products-table-row__cell-vertical-align--center"
                >
                    <span>
                        {quoteTooltip}
                        <span className="broker-products-table-row__quote-eur">
                            {quoteAmountEurBlock}
                        </span>
                    </span>
                    <div className="broker-products-table-row__second-row">
                        {divider}
                    </div>
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-products-table-row__value-row broker-products-table-row__cell-vertical-align--center"
                >
                    <span>
                        <span className="broker-products-table-row__value">
                            {formattedValue}
                        </span>
                        <span className="broker-products-table-row__value-eur">
                            {formattedValueEur}
                        </span>
                    </span>
                    <div className="broker-products-table-row__second-row">
                        {this.buildUnconsolidatedOperationsValues(immStock, finalType, false)}
                    </div>
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-products-table-row__earnings-row broker-products-table-row__cell-vertical-align--center"
                >
                    <span>
                        <span className="broker-products-table-row__earnings">
                            {formattedEarnings}
                        </span>
                        <span className="broker-products-table-row__earnings-eur">
                            {formattedEarningsEur}
                        </span>
                    </span>
                    <div className="broker-products-table-row__second-row">
                        {divider}
                    </div>
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-products-table-row__in-wallet broker-products-table-row__cell-vertical-align--center"
                >
                    <div className="broker-products-table-row__in-wallet-eur">
                        {formattedPercentageInWallet}%
                    </div>
                    <div className="broker-products-table-row__second-row">
                        {divider}
                    </div>
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-products-table-row__operate-column broker-products-table-row__action-vertical-align--center"
                >
                    {operateButtons}
                </OKTableCell>
            </OKTableRow>
        );

    }

    buildTooltipContent(iban) {
        return (
            <span>
                {iban}
                <button
                    className="icon__tooltip icon-copiar"
                    onClick={() => this.copyIbanToClipboard(iban)}
                >
                </button>
            </span>
        );
    }

    buildTotalValue(operations, prefix = '') {
        const totalValue = operations.get('totalValue');
        const valueCurrency = (
            <span className="broker-products-table-row__unconsolidated-values-currency">
                {operations.get('totalValueCurrency')}
            </span>
        );
        const decimalTotalValue = formatWithoutRound(totalValue, 2);
        const formattedTotalValue = `${prefix}${decimalTotalValue}`;
        return this.buildAmountCurrency(formattedTotalValue, valueCurrency);
    }

    buildUnconsolidatedOperations(immStock, type) {
        if (!this.hasUnconsolidatedOperations(immStock)) {
            return null;
        }

        let totalOperationsTitle, unconsolidatedOperationsTitle

        switch (type) {
            case TYPE_STOCKS:
                totalOperationsTitle = formatText('broker-brokerTotalOperationsStocks');
                unconsolidatedOperationsTitle = formatText('broker-brokerUnconsolidatedOperationsStocks');
                break;
            case TYPE_WARRANTS:
                totalOperationsTitle = formatText('broker-brokerTotalOperationsWarrants');
                unconsolidatedOperationsTitle = formatText('broker-brokerUnconsolidatedOperationsWarrants');
                break;
            case TYPE_ETFS:
                totalOperationsTitle = formatText('broker-brokerTotalOperationsETFS');
                unconsolidatedOperationsTitle = formatText('broker-brokerUnconsolidatedOperationsETFS');
                break;
            case TYPE_FUNDS:
                totalOperationsTitle = formatText('broker-brokerTotalOperationsFunds');
                unconsolidatedOperationsTitle = formatText('broker-brokerUnconsolidatedOperationsFunds');
                break;
            case TYPE_PLANS:
                totalOperationsTitle = formatText('broker-brokerTotalOperationsPlans');
                unconsolidatedOperationsTitle = formatText('broker-brokerUnconsolidatedOperationsPlans');
                break;
        }

        return (
            <div>
                <div className="broker-products-table-row__unconsolidated-operations">
                    {unconsolidatedOperationsTitle}
                </div>
                <hr className="broker-products-table-row__unconsolidated-divider" />
                <div className="broker-products-table-row__total-operations">
                    {totalOperationsTitle}
                </div>
            </div>
        );
    }

    buildUnconsolidatedOperationsDivider(type) {
        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
            case TYPE_FUNDS:
            case TYPE_PLANS:
                return (
                    <hr className="broker-products-table-row__divider" />
                );
        }
    }

    buildUnconsolidatedOperationsValueDivider(type) {
        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
            case TYPE_FUNDS:
            case TYPE_PLANS:
                return (
                    <hr className="broker-products-table-row__unconsolidated-divider-value" />
                );
        }
    }

    buildUnconsolidatedOperationsValues(immStock, type, isShares) {
        if (!this.hasUnconsolidatedOperations(immStock)) {
            return null;
        }

        const unconsolidatedOperations = immStock.get('unconsolidatedOperations');
        const totalOperations = immStock.get('totalOperations');
        let unconsolidatedValue;
        let totalValue;

        if (!isShares) {
            const unconsolidatedValuesValue = unconsolidatedOperations.get('totalValue');
            const totalOperationsValuesValue = totalOperations.get('totalValue');
            let unconsolidatedParsedValue;
            if (unconsolidatedValuesValue > 0) {
                unconsolidatedParsedValue = this.buildTotalValue(unconsolidatedOperations, '+');
            } else {
                unconsolidatedParsedValue = this.buildTotalValue(unconsolidatedOperations);
            }
            unconsolidatedValue = conditionalValueOrHyphen(unconsolidatedValuesValue != null, unconsolidatedParsedValue);
            totalValue = conditionalValueOrHyphen(totalOperationsValuesValue != null, this.buildTotalValue(totalOperations));
        } else {
            const unconsolidatedSharesValue = unconsolidatedOperations.get('shares');
            const totalOperationsSharesValue = totalOperations.get('shares');

            unconsolidatedValue = valueOrHyphen(unconsolidatedSharesValue);
            totalValue = valueOrHyphen(totalOperationsSharesValue);

            if (type === TYPE_FUNDS || type === TYPE_PLANS) {
                if (unconsolidatedSharesValue != null) {
                    unconsolidatedValue = formatAmount(unconsolidatedSharesValue, undefined, 3);
                }

                if (totalOperationsSharesValue != null) {
                    totalValue = formatAmount(totalOperationsSharesValue, undefined, 3);
                }
            }

            if (unconsolidatedSharesValue > 0) {
                unconsolidatedValue = '+' + unconsolidatedValue;
            }
        }

        const divider = this.buildUnconsolidatedOperationsValueDivider(type);
        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
            case TYPE_FUNDS:
            case TYPE_PLANS:
                return (
                    <div className="broker-products-table-row__total-operations-value">
                        <div className="broker-products-table-row__unconsolidated-value">
                            {unconsolidatedValue}
                        </div>
                        {divider}
                        <div className="broker-products-table-row__total-value">
                            {totalValue}
                        </div>
                    </div>
                );
        }
    }

    copyIbanToClipboard(iban) {
        sendTextToClipBoard(iban);
    }

    handleBuy(buyLink, finalType, productName) {
        taggingEventHandled(this.props.pageName, 'actionButtonBuy', productName, finalType);
        if (BROKER_NON_NATIONAL_IDS_VALIDATION_TYPES.indexOf(finalType) !== -1){
            return this.props.history.push(buyLink);
        }
        this.props.onHandleBuyClick(buyLink);
    }

    handleSell(immStock, sellLink, contractNumber, finalType, productName) {
        const { setSellContract, isContractSection, history } = this.props;
        const choosedIsin = immStock.get('isin');
        const extraEventTag = {'funds': ' - inAccount'}
        taggingEventHandled(this.props.pageName, 'actionButtonSell', productName, {finalType, extraTag: extraEventTag[finalType] || ''});
        if (isContractSection) {
            let contract = this.getContract('stocks', choosedIsin, contractNumber);
            const etfsContract = this.getContract('etfs', choosedIsin, contractNumber);
            contract = etfsContract ? etfsContract : contract;
            const warrantsContract = this.getContract('warrants', choosedIsin, contractNumber);
            contract = warrantsContract ? warrantsContract : contract;
            setSellContract(contract, false)
        }
        if (BROKER_NON_NATIONAL_IDS_VALIDATION_TYPES.indexOf(finalType) !== -1 || finalType === TYPE_CRYPTO_PG){
            return history.push(sellLink);
        }
        this.props.onHandleBuyClick(sellLink);
    }

    hasUnconsolidatedOperations(immStock) {
        const hasIntradiaValues = immStock.getIn([
            'unconsolidatedOperations',
            'hasUnconsolidatedOperations',
        ]);

        const unconsolidatedOperations = immStock.get('unconsolidatedOperations');
        const hasValidIntradiaValues = unconsolidatedOperations.get('hasValidIntradiaValues');

        return hasIntradiaValues && hasValidIntradiaValues;
    }

    productFileLink(type, value) {
        let isin = value.get('isin');
        const iso = value.get('iso');
        switch (type) {
            case TYPE_CRYPTO_PG:
                return `${MYPROFILE_BROKER_CRYPTO_URL}/product/${formatSymbol(isin)}`;
            case TYPE_STOCKS:
            case TYPE_CRYPTO_PG:
                return `/myprofile/broker/productFile/${isin}/${iso}`;
            case TYPE_WARRANTS:
            case TYPE_ETFS:
                return `/myprofile/broker/${type}ProductFile/${isin}/${iso}`;
            case TYPE_PLANS:
                isin = value.get('isin');
                return getPublicSitePathByLanguaje('brokerURL-brokerURL_pensionPlanOnPublic', { isin: isin });
            case TYPE_FUNDS:
                return buildLinks(isin, value.get('id'));
            case TYPE_ALTERNATIVE_FUNDS_PG:
                return buildLinks(isin, value.get('id'), true);
        }
    }

    showFlagMarketAndCode(finalType, immStock){
        const flag = this.getFlag(finalType, immStock);
        const code = this.getCode(finalType, immStock);
        const marketName = this.getMarketName(finalType, immStock);
        switch (finalType) {
            case TYPE_ALTERNATIVE_FUNDS_PG:
            case TYPE_FUNDS:
            case TYPE_PLANS:
                return code;
            case TYPE_WARRANTS:
                return <span>{flag} {code}</span>
            case TYPE_ETFS:
                if (marketName!==null) {
                    return <React.Fragment><span>{flag} {marketName} | </span><span className="broker-products-table-row__product-code--isin">{code}</span></React.Fragment>
                } else {
                    return <React.Fragment><span>{flag} {HYPHEN} | </span><span className="broker-products-table-row__product-code--isin">{code}</span></React.Fragment>
                }
            case TYPE_STOCKS:
                if (marketName!==null) {
                    return <span>{flag} {marketName} | {code}</span>
                } else {
                    if (code===HYPHEN){
                        return <span>{flag} {code}</span>
                    } else {
                        return <span>{flag} {HYPHEN} | {code}</span>
                    }
                }
        }
    }

    render() {
        const { immStock, type } = this.props;
        return this.buildRow(immStock, type);
    }
}

BrokerMyInvestmentsProductsRow.propTypes = {
    history: PropTypes.object.isRequired,
    immStock: PropTypes.object,
    immMyInvestments: PropTypes.object,
    type: PropTypes.string,
    setSellContract: PropTypes.func.isRequired,
    isContractSection: PropTypes.bool,
    onHandleBuyClick: PropTypes.func,
    onPreSelectOriginInternalTransferFund: PropTypes.func.isRequired,
    pageName: PropTypes.string,
    hasContributionsFund: PropTypes.string,
};


module.exports.constructor = BrokerMyInvestmentsProductsRow;
module.exports.BrokerMyInvestmentsProductsRow = connect((state) => ({
    immFlagBasedFeatures: state.flagBasedFeatures,
}), {}
)(withRouter(BrokerMyInvestmentsProductsRow));
